<template>
  <v-text-field
    v-model="string"
    :label="label"
    type="text"
    solo-inverted
    dense
    prepend-icon="mdi-account-search"
  ></v-text-field>
</template>
<script>
export default {
  name: "components-common-filters-InputStringLog",
  data: () => ({
    string: "",
  }),
  computed: {
    label() {
      return this.$t("inputStringLabel");
    },
  },
  watch: {
    string(value) {
      this.$store.commit("setInputStringLog", value);
    },
  },
};
</script>
